import ReactGA from 'react-ga4';

export function redirect(url, openInBlankPage = true) {
  openInBlankPage ? window.open(url, '_blank') : window.open(url);
}

export function logAnalytics({ category, action, label }) {
  ReactGA.event({ category, action, label });
}
